import { Col, Form as ReactForm, Table as ReactTable, Row } from 'react-bootstrap';
import { SalvButton, SalvFieldHeader, SalvTextField, Size } from '@salvapp/ui-components';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { ErrorMessage } from 'formik';

interface Props {
  dropdownOptions: string[];
  setDropdownOptions: (values: string[]) => void;
}

const SchemaDropdownOptionsDEPRECATED = ({ dropdownOptions, setDropdownOptions }: Props) => {
  return (
    <Row className='m-t-4'>
      <Col>
        <SalvFieldHeader
          label='Define dropdown options'
          description='These options will be visible under the dropdown'
        />
        <ReactTable size='sm' className='card-table' striped>
          <thead>
            <tr>
              <th className='text-strong-xs'>Option name</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {dropdownOptions.map((option, index: number) => {
              const removeRow = () => {
                const newValues = [...dropdownOptions!];
                newValues.splice(index, 1);
                setDropdownOptions(newValues);
              };
              const updateRow = (value: string) => {
                const newValues = [...dropdownOptions!];
                newValues[index] = value;
                setDropdownOptions(newValues);
              };
              return (
                <tr key={index}>
                  <td>
                    <SalvTextField
                      ariaLabel={`Option ${index + 1}`}
                      value={option}
                      placeholder={`Option ${index + 1}`}
                      onChange={(value) => updateRow(value)}
                    />
                  </td>
                  <td className='text-end'>
                    <SalvButton
                      label={'Remove'}
                      variant='danger-outline'
                      size={Size.SMALL}
                      disabled={dropdownOptions.length <= 1}
                      onClick={removeRow}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </ReactTable>
        <ErrorMessage
          name={`dropdownOptions`}
          render={(message) => (
            <ReactForm.Control.Feedback type='invalid' className='d-block'>
              {message}
            </ReactForm.Control.Feedback>
          )}
        />
        <Row className='mb-0 mt-3'>
          <SalvButton
            icon={faPlus}
            label={'Add option'}
            variant='secondary'
            size={Size.SMALL}
            onClick={() => {
              setDropdownOptions([...dropdownOptions!, '']);
            }}
          />
        </Row>
      </Col>
    </Row>
  );
};

export default SchemaDropdownOptionsDEPRECATED;
